module.exports = __webpack_public_path__ + "assets/8d86bd3b7272a81ae8cf9fd1e8b242b0.png";